module.exports = __webpack_public_path__ + "img/save.0b04d03e.png";